// extracted by mini-css-extract-plugin
export default {"iframeTile":"IframeTile__iframeTile--FaV"};